import CRUD from './crud'

export default new CRUD('tournament-judge-participants', 'superior-judge')
